module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piii"
    }
  }), _vm._v("The Ark and Beyond")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("The Evolution of Zoo and Aquarium Conservation")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Edited by Ben A. Minteer, Jane Maienschein, and James P. Collins")]), _vm._v(" "), _c('p', {
    staticClass: "bkau1",
    staticStyle: {
      "margin-top": "3em",
      "margin-bottom": "0"
    }
  }, [_vm._v("with a Foreword by")]), _vm._v(" "), _c('p', {
    staticClass: "bkau",
    staticStyle: {
      "margin-top": "0.5em"
    }
  }, [_vm._v("GEORGE RABB")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("The University of Chicago Press")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHICAGO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("&")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LONDON")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ca6861","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-minteer-0004.vue
// module id = 63
// module chunks = 0